.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  width: 100%;

  .body {
    flex: 1;
    display: flex;
    flex-direction: row;
    min-height: min-content;
    width: 100%;

    .sidebar {
      order: 1;
      min-width: 290px;
      height: 100%;
      background-color: #074f86;
      border-right: 1px solid #979797;
      color: #fff;
      position: relative;

      &.collapsed {
        min-width: var(--sidebar-width);
      }
    }

    .main {
      order: 2;
      flex: 1;
      padding: 20px 40px;
      position: relative;
      min-height: min-content;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
    }
  }
}

.menuLoading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
